export default {
  COLOR_BACKGROUND_MAP: '#F5F5F5',
  COLOR_MARKER_BORDER: '#333333',
  COLOR_MARKER_FILL: '#333333',
  COLOR_MARKER_TEXT: '#FFFFFF',
  COLOR_LINE: '#CC0000'
}
